import {
    Injectable,
    OnInit,
    ElementRef,
    Renderer2
} from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class NotificationsMenuService {

    public notificationsObservable$: Observable<any>;
    private _notificationsObservableSubject: Subject<any>;

    public amoutObservable$: Observable<any>;
    private _amoutObservableSubject: Subject<any>;

    /**
     * just test
     */
    private notificationsItens: Array<any>;
    private notificationsAddItens: Array<any>;

    constructor() {
        this._amoutObservableSubject = new Subject();
        this.amoutObservable$ = this._amoutObservableSubject.asObservable();

        this._notificationsObservableSubject = new Subject();
        this.notificationsObservable$ = this._notificationsObservableSubject.asObservable();
    }

    /**
     * interfaces for websocket!!
     */
    getAndUpdate_Notifications() {

        /**
         * Just test
         */

        if (!this.notificationsItens) {
            this.notificationsItens = [
                {
                    id: 1,
                    type: 0,
                    text: '',
                    resume: 'Esse ativo não é negociado em bolsa. Você terá que revisar o seu pedido de…',
                    time: ''
                },
                {
                    id: 2,
                    type: 1,
                    text: '',
                    resume: 'O seu investimento em PETR4 passou por um evento chamado grupamento…',
                    time: ''
                },
                {
                    id: 3,
                    type: 2,
                    text: '',
                    resume: 'Sua conta precisa ser recadastrada',
                    time: ''
                },
                {
                    id: 4,
                    type: 2,
                    text: '',
                    resume: 'Seu pedido de saque está em análise e em breve nossa equipe entrará em cont…',
                    time: ''
                },
                {
                    id: 5,
                    type: 2,
                    text: '',
                    resume: 'Sua conta foi aberta com sucesso',
                    time: ''
                }
            ];
        }

        setTimeout(() => {
            if (this.notificationsAddItens) {
                for (let item of this.notificationsAddItens) {
                    this.notificationsItens.unshift(item);
                }
                this.notificationsAddItens = [];
                this.updateAmout( this.notificationsAddItens.length );
            }
            this._notificationsObservableSubject.next(this.notificationsItens)
        }, 1300);
    }

    getAndUpdate_AmoutNotifications() {
        /**
         * Just test
         */

        // setTimeout(() => {
        //     this._amoutObservableSubject.next(1);
        // }, 1000);

        // setTimeout(() => {
        //     this._amoutObservableSubject.next(300);
        // }, 2500);
    }

    /**
     * Just test, send datas for interfaces
     */
    
    updateAmout(ms) {
        this._amoutObservableSubject.next(Number(ms));
    }

    updateNotifications(item) {
        if (!this.notificationsAddItens) {
            this.notificationsAddItens = [];
        }
        this.notificationsAddItens.push(item);
        this.updateAmout( this.notificationsAddItens.length )
    }
}